import React, { useEffect, useRef } from 'react';
import Shared from '../../Components/Frame/Shared';
import * as rsuite from 'rsuite';
import { Table } from 'rsuite';
import { useState } from 'react';
import * as General from '../../General/General';
import axios from 'axios';
import { FaUser } from "react-icons/fa";
import { isMobile } from 'react-device-detect';
import Delete from '../../Components/Shared/Delete';
import * as Enum from '../../General/Enum';
import { useNavigate } from 'react-router-dom';
import { BiSolidCategory } from "react-icons/bi";
import Drp_Project from '../../Components/Project/Drp_Projects';
import TopicProp from '../../Components/Topic/TopicProp';
import UpdateParentProp from '../../Components/Topic/UpdateParentProp';
const { Column, HeaderCell, Cell } = Table;



const Index = () => {

    //#region Const

    let navigate = useNavigate();

    const [showModal, setShowModal] = useState(false);
    const [ShowUpdateModal, setShowUpdateModal] = useState(false);
    const [showDrawer, setShowDrawer] = useState(false);
    const [ShowUpdateDrawer, setShowupdateDrawer] = useState(false);
    const [Nodes, setNodes] = useState([]);
    const [ShowLoader, setShowLoader] = useState(true);
    const [ProjectId, setProjectId] = useState(General.GuidEmpty());
    const [ParentId, setParentId] = useState(General.GuidEmpty());
    const ref = useRef();
    const Updateref = useRef();
    const DeleteRef = useRef();

    const ProjectRef = useRef();
    //#endregion




    const ShowDelete = () => {

        DeleteRef.current.Show(Enum.DeleteType.Topic, ParentId);
    }
    const handleProp = (Id) => {
        if (Id === General.GuidEmpty() && ProjectId === General.GuidEmpty()) {
            General.ShowMsg(Enum.MsgType.error, "ابتدا پروژه را انتخاب نمایید");
            return;
        }
        if (isMobile) {
            setShowDrawer(true);
        } else {
            setShowModal(true);

        }
        setTimeout(() => {

            ref.current.ShowEdit(Id);

            ref.current.SetProjectParent(ProjectId, ParentId);
        }, 500);

    };
    const handleUpdateProp = (Id) => {
        if (Id === General.GuidEmpty() && ProjectId === General.GuidEmpty()) {
            General.ShowMsg(Enum.MsgType.error, "ابتدا پروژه را انتخاب نمایید");
            return;
        }
        if (isMobile) {
            setShowupdateDrawer(true);
        } else {
            setShowUpdateModal(true);

        }
        setTimeout(() => {

            Updateref.current.setId(Id);


        }, 500);

    };
    const Bind = () => {
        var RequestOption = {
            method: "Post",
            url: General.ApiRoute() + "/Topic/BindTree",
            headers: {
                "ApiKey": process.env.REACT_APP_APIKEY,
                "ProjectId": ProjectId,
                "IsActive": -1
            },
            withCredentials: true
        }
        axios(RequestOption)
            .then(function (res) {
                setNodes(res.data);
                setShowLoader(false)
            })

            .catch(error => {
                if (error.response) {
                    if (error.response.status === 401) {
                        navigate("/UnAuthorize")
                    }
                    else if (error.response.status === 403) {
                        navigate("/AccessDenied")
                    }
                }
                else {
                    General.ShowMsg(Enum.MsgType.error, General.UnkownException(error));
                    setShowLoader(false);
                }
            })
    }


    const SelectProject = (e) => {
        setProjectId(e);
    }

    useEffect(() => {
        Bind();
        ProjectRef.current.Get();
    }, [])

    useEffect(() => {
        Bind();
    }, [ProjectId])

    return (
        <Shared pageTitle={<><BiSolidCategory size={25} /> اسناد راهنما</>}>

            <div align="left">
                <rsuite.Stack justifyContent='flex-end' spacing={6}>
                    <Drp_Project ref={ProjectRef} onSelect={SelectProject} />
                    <rsuite.Button appearance="primary" className="mb-2" onClick={() => handleProp(General.GuidEmpty())}>
                        ایجاد سند جدید
                    </rsuite.Button>
                    <rsuite.Button appearance="default" className="mb-2" onClick={() => handleProp(ParentId)}>
                        ویرایش
                    </rsuite.Button>
                    <rsuite.Button appearance="default" className="mb-2" onClick={() => handleUpdateProp(ParentId)}>
                        تغییر والد
                    </rsuite.Button>
                    <rsuite.Button appearance="primary" color="red" className="mb-2" onClick={() => ShowDelete()}>
                        حذف
                    </rsuite.Button>
                </rsuite.Stack>

            </div>
            <rsuite.Divider />

            {
                !showModal ?
                    <>

                        <div style={{ direction: 'rtl' }}>
                            <rsuite.Tree
                                searchable
                                data={Nodes}
                                value={ParentId}
                                onChange={Value => setParentId(Value)}
                                renderTreeNode={node => {
                                    return (
                                        <>
                                            {node.label}
                                        </>
                                    );
                                }}
                            />
                        </div>
                    </> :
                    <div className="FullScreen" >

                        <rsuite.Button onClick={() => setShowModal(false)}>بستن</rsuite.Button>
                        <TopicProp ref={ref} onSubmit={() => (setShowModal(false), Bind())} />


                    </div>

            }




            <rsuite.Modal open={ShowUpdateModal} onClose={() => setShowUpdateModal(false)} size="md">
                <rsuite.Modal.Header>
                    <rsuite.Modal.Title>تغییر والد</rsuite.Modal.Title>
                </rsuite.Modal.Header>
                <rsuite.Modal.Body>
                    <UpdateParentProp ref={Updateref} onSubmit={() => (setShowUpdateModal(false), Bind())} />
                </rsuite.Modal.Body>
            </rsuite.Modal>
            <rsuite.Drawer open={ShowUpdateDrawer} onClose={() => setShowupdateDrawer(false)} placement="right" size="xs">
                <rsuite.Drawer.Header>
                    <rsuite.Drawer.Title>تغییر والد</rsuite.Drawer.Title>
                </rsuite.Drawer.Header>
                <rsuite.Drawer.Body>
                    <TopicProp ref={Updateref} onSubmit={() => (setShowupdateDrawer(false), Bind())} />
                </rsuite.Drawer.Body>
            </rsuite.Drawer>
            <Delete ref={DeleteRef} onSubmit={Bind} />
        </Shared>
    );



}

export default Index;
